export default __webpack_public_path__ + "static/media/travelEasy.b813b3fd.png";